const MIN_MAX = {
  acceleration: {
    min: 0,
    max: 10,
  },
  deceleration: {
    min: -10,
    max: 0,
  },
  speed: {
    min: 0,
    max: 44.7,
  },
  hr: {
    min: 40,
    max: 220,
  },
}
const MIN_MAX_PLAYER_METRIC = {
  acceleration: {
    min: 0,
    max: 150,
  },
  hr: {
    min: 0,
    max: 100,
  },
}

const NEW_TYPE = {
  acceleration: "acceleration",
  deceleration: "acceleration",
  speed: "speed",
  hr: "hr",
}
const ZONE_CODE_BY_TYPE = {
  acceleration: "accelZone",
  deceleration: "decelZone",
  speed: "speedZone",
  hr: "hrZone",
}

const DEFAULT_TYPE_UNIT = {
  speed: "km/h",
  acceleration: "m/s^2",
  deceleration: "m/s^2",
  hr: "bpm",
}

export { MIN_MAX, MIN_MAX_PLAYER_METRIC, NEW_TYPE, DEFAULT_TYPE_UNIT, ZONE_CODE_BY_TYPE }
